import React from "react";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { Custom } from "components";
import { useApp, useTheme } from "contexts";

// icons
import {
  CloseRounded,
  DriveFileRenameOutlineRounded,
  SendOutlined,
  DeleteOutlineRounded,
  MoreVertRounded,
  VisibilityOffRounded,
} from "@mui/icons-material";

type Props = {
  id: string;
  isOwner: boolean;
  isActive: boolean;
  onHide: (id: string) => void;
  onEdit: (id: string) => void;
  onWithdrawal: (id: string) => void;
  onManageInvitation: (id: string) => void;
  onDelete: (id: string) => void;
};

export const Potluck = ({
  id,
  isActive,
  isOwner,
  onHide,
  onEdit,
  onWithdrawal,
  onManageInvitation,
  onDelete,
}: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Custom.IconButton
        id="three-dots-menu"
        aria-label="more"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertRounded />
      </Custom.IconButton>

      <Custom.Menu id="menu" anchorEl={anchorEl} onClose={handleClose}>
        {isActive && isOwner && (
          <MenuItem
            onClick={() => {
              handleClose();
              onEdit(id);
            }}
          >
            <ListItemIcon>
              <DriveFileRenameOutlineRounded />
            </ListItemIcon>
            <ListItemText>{t.action.edit}</ListItemText>
          </MenuItem>
        )}
        {isActive && isOwner && (
          <MenuItem
            onClick={() => {
              handleClose();
              onManageInvitation(id);
            }}
          >
            <ListItemIcon>
              <SendOutlined />
            </ListItemIcon>
            <ListItemText>{t.action.manage_invitation}</ListItemText>
          </MenuItem>
        )}
        {!isActive && (
          <MenuItem
            onClick={() => {
              handleClose();
              onHide(id);
            }}
          >
            <ListItemIcon>
              <VisibilityOffRounded />
            </ListItemIcon>
            <ListItemText>{t.action.hide}</ListItemText>
          </MenuItem>
        )}
        {isOwner && (
          <MenuItem
            onClick={() => {
              handleClose();
              onDelete(id);
            }}
          >
            <ListItemIcon>
              <DeleteOutlineRounded sx={{ color: theme.color.status.error }} />
            </ListItemIcon>
            <ListItemText sx={{ color: theme.color.status.error }}>
              {t.action.delete}
            </ListItemText>
          </MenuItem>
        )}
        {!isOwner && isActive && (
          <MenuItem
            onClick={() => {
              handleClose();
              onWithdrawal(id);
            }}
          >
            <ListItemIcon>
              <CloseRounded sx={{ color: theme.color.status.error }} />
            </ListItemIcon>
            <ListItemText sx={{ color: theme.color.status.error }}>
              {t.action.withdrawal_invitation}
            </ListItemText>
          </MenuItem>
        )}
      </Custom.Menu>
    </>
  );
};
